import { render, staticRenderFns } from "./accuracy.vue?vue&type=template&id=ae4a62b4"
import script from "./accuracy.vue?vue&type=script&lang=js"
export * from "./accuracy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports